import { defineMessages } from 'react-intl'

export default defineMessages({
  confirm: {
    id: 'ConfirmationOverlay.confirm',
    defaultMessage: 'Are you sure?'
  },
  add: {
    id: 'ConfirmationOverlay.add',
    defaultMessage: 'Add'
  },
  cancel: {
    id: 'ConfirmationOverlay.cancel',
    defaultMessage: 'Cancel'
  }
})
